module.exports = __webpack_public_path__ + "img/italgas-banner.9c3996c2.jpg";